﻿import { HubConnectionBuilder } from "@microsoft/signalr";

class DeviceHub {
    constructor() {
        this.client = new HubConnectionBuilder()
            .withUrl("/device-hub")
            //.withAutomaticReconnect([0, 1000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 20000, 30000, 60000, 60000, 60000, 60000, 60000, 60000, 60000])
            .build();

        this.client.onclose((error) => {
            
            console.log('Websocket connection disconnected! Attempting to start connection in 2 seconds ...');
            window.postMessage({ event: 'connectionClosed', args: error }, '*');
            setTimeout(() => {
                this.start();
            }, 2000);
        });

        this.client.onreconnected(() => {
            window.postMessage({ event: 'connectionReconnected'}, '*');
            this.client.invoke("SetAccount", window.ACCOUNT_ID);
        });
    }

    start() {
        this.client.start().then(res => {
            console.log('WS connection started');
            this.client.invoke("SetAccount", window.ACCOUNT_ID);
            window.postMessage({ event: 'connectionStarted', args: { 'foo': 'bar' } }, '*');
        }).catch(error => {
            console.log('Error in WS start!');
            setTimeout(() => {
                this.start();
            }, 2000);
        });
    }
}

export default new DeviceHub();